// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir=ltr] .kit-item-name[data-v-9398071a] {\n  padding-left: 20px;\n}\n[dir=rtl] .kit-item-name[data-v-9398071a] {\n  padding-right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
